import { InjectionToken } from '@angular/core';
import { IcontestDataResponse } from 'app/features/contest/models/contest-api.models';
import { GenderType } from 'app/features/contest/models/gender';
import { IUserInfo } from 'app/features/contest/models/contest-user-info.models';
import { Observable } from 'rxjs';

export type ContestRankingMode =
  | 'top_ranking_chrono'
  | 'top_ranking_distance'
  | 'top_ranking_ppr'
  | 'top_ranking_wpk';
export type ContestDataMode = ContestRankingMode | 'last_activities';

export const LEADERBOARD_MODE = new InjectionToken<ContestDataMode>('LEADERBOARD_MODE');

export type ContestDataQuery = {
  hashid: string;
  mode: ContestDataMode;
  page: number;
  pprFilter: number;
  targetGender: GenderType;
  username: string;
};

export type DeleteActivityResponse = {
  message: string;
};

export abstract class ContestApi {
  abstract deleteActivity(activityId: number): Observable<DeleteActivityResponse>;

  abstract exportData(
    contestUsername: string,
    hashId: string,
    pprFilter: number,
    email: string
  ): Observable<unknown>;

  abstract getContestData(query: ContestDataQuery): Observable<IcontestDataResponse>;

  abstract getUserInfo(username: string, hashid: string): Observable<IUserInfo>;

  abstract resetData(contestUsername: string, hashId: string): Observable<unknown>;
}
